import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import MonetVideo from "../media/videos/Monet-Demo-v2.mp4";

export default function MonetModal({ open, setOpen, email, setEmail, handleEmail }) {
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => setOpen(null)}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-void/80 backdrop-blur-sm transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="relative w-full max-w-4xl rounded-2xl border border-border-subtle bg-surface p-6 sm:p-8 shadow-2xl">
                                <button
                                    type="button"
                                    className="absolute top-4 right-4 text-text-muted hover:text-text-primary transition-colors"
                                    onClick={() => setOpen(null)}
                                >
                                    <XMarkIcon className="h-6 w-6" />
                                    <span className="sr-only">Close</span>
                                </button>

                                <Dialog.Title as="h3" className="font-syne text-2xl font-bold text-accent text-center mb-6">
                                    Monet.ai
                                </Dialog.Title>

                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-2/3">
                                        <video src={MonetVideo} autoPlay loop muted className="rounded-xl w-full">
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                    <div className="md:w-1/3">
                                        <p className="font-outfit text-sm text-text-secondary leading-relaxed">
                                            Monet.ai is a Gen-AI art-to-print platform that revolutionizes home decor &amp; print-ready art. Development is ongoing — stay up to date below.
                                        </p>
                                        <form onSubmit={handleEmail} className="mt-6">
                                            <label htmlFor="monet-email" className="font-outfit text-sm font-medium text-text-primary block mb-2">
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="monet-email"
                                                className="w-full rounded-lg border border-border-medium bg-elevated px-4 py-2.5 text-sm text-text-primary placeholder:text-text-muted focus:ring-1 focus:ring-accent focus:border-accent font-outfit"
                                                placeholder="you@example.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                            <p className="mt-2 text-xs text-text-muted font-outfit">
                                                Only for serious updates.
                                            </p>
                                            <button
                                                type="submit"
                                                className="mt-4 w-full px-4 py-2.5 rounded-lg bg-accent text-void font-outfit font-semibold text-sm hover:shadow-[0_0_20px_rgba(34,211,238,0.3)] transition-all duration-300"
                                            >
                                                Submit
                                            </button>
                                        </form>
                                    </div>
                                </div>

                                <p className="mt-6 text-center font-outfit text-sm text-text-muted">
                                    Coming Soon
                                </p>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
